<template>
  <div class="mt-1">
    <b-table :items="items" :fields="fields" small responsive>
      <template #cell()="data">
        <div v-if="data.value.price >= 0">
          {{ currency(data.value.price) }}
          <b-badge
            v-if="data.value.rate !== 0 && data.value.rate > 0"
            pill
            variant="light-success"
            class="ml-1"
          >
            +{{ data.value.rate }}%
          </b-badge>
          <b-badge
            v-if="data.value.rate !== 0 && data.value.rate < 0"
            pill
            variant="light-secondary"
            class="ml-1"
          >
            {{ data.value.rate }}%
          </b-badge>
        </div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>
    </b-table>

    <div
      class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1 mt-1"
    >
      <small></small>
      <small class="timeline-item-time text-nowrap text-muted ml-1"
        >Source: Adéquation</small
      >
    </div>
  </div>
</template>

<script>
import { BTable, BBadge } from "bootstrap-vue";
import { currency, evalTrend, formatPeriodQuarter } from "@core/utils/filter";

export default {
  components: {
    BTable,
    BBadge,
  },
  props: {
    ventesByPeriode: {
      type: Object,
      required: true,
    },
  },
  methods: {
    currency,
    evalTrend,
  },
  data() {
    const items = [];

    var lastElem = null;
    this.ventesByPeriode.data.forEach((element) => {
      if (lastElem != null) {
        items.push({
          year: formatPeriodQuarter(element.period),
          price_per_meter_sales: {
            price: element.new_lodgment_trends.price_per_meter_sales,
            rate: evalTrend(
              element.new_lodgment_trends.price_per_meter_sales,
              lastElem.new_lodgment_trends.price_per_meter_sales
            ),
          },
          price_per_meter_available_offer: {
            price: element.new_lodgment_trends.price_per_meter_available_offer,
            rate: evalTrend(
              element.new_lodgment_trends.price_per_meter_available_offer,
              lastElem.new_lodgment_trends.price_per_meter_available_offer
            ),
          },
        });
      } else {
        items.push({
          year: formatPeriodQuarter(element.period),
          price_per_meter_sales: {
            price: element.new_lodgment_trends.price_per_meter_sales,
            rate: 0,
          },
          price_per_meter_available_offer: {
            price: element.new_lodgment_trends.price_per_meter_available_offer,
            rate: 0,
          },
        });
      }
      lastElem = element;
    });

    return {
      fields: [
        {
          key: "year",
          label: "Année",
        },
        {
          key: "price_per_meter_sales",
          label: "Prix/m² moyen de vente",
        },
        {
          key: "price_per_meter_available_offer",
          label: "Prix/m² moyen de l'offre",
        },
      ],
      items,
    };
  },
};
</script>
